import React from "react";
import { PageHeader } from "@finitless/shared/components";

/**
 * Centralized error state component for OverviewPage
 * @param {Object} props - Component props
 * @param {Object} props.selectedBrand - Selected brand for header
 * @param {string} props.welcomeMessage - Welcome message to display
 * @param {Error} props.error - Error object to display
 * @param {string} props.fallbackMessage - Fallback message if no specific error message
 */
const ErrorState = ({
  selectedBrand,
  welcomeMessage,
  error,
  fallbackMessage = "Unable to fetch metrics. Showing sample data instead.",
}) => {
  const errorMessage = error?.message || fallbackMessage;

  return (
    <div>
      <PageHeader title="Overview" selectedBrand={selectedBrand}>
        <p className="text-lg text-gray-300">{welcomeMessage}</p>
      </PageHeader>

      <div className="mb-6 rounded-lg border border-red-500/30 bg-red-900/20 p-6">
        <div className="flex items-center space-x-3">
          <div className="text-red-500">
            <svg
              className="h-6 w-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"
              />
            </svg>
          </div>
          <div>
            <h3 className="text-lg font-medium text-red-400">
              Failed to load dashboard data
            </h3>
            <p className="mt-1 text-sm text-red-300">{errorMessage}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export { ErrorState };
